import { ActionTypes } from "../constants";

var initialState = {
                    pan: '',
                    currentStep: '',
                    addPan: {
                      pan: '',
                      dob: '', 
                      formattedDob: ''
                    },
                    kycContactDetails: {
                      dob: '',
                      phone: ''
                    },
                    kycVerificationStatus: ''
                  }

export default function onboarding(state = initialState, action) {

  switch(action.type) {
    case ActionTypes.SET_CURRENT_ONBOARDING_STEP:
      return {
        ...state,
        currentStep: action.payload
      }
    case ActionTypes.SET_CURRENT_ACCOUNT_ONBOARDING_STAGE:
      return {
        ...state,
        currentStage: action.payload
      }
    case ActionTypes.SET_ONBOARDING_DATA_ADD_PAN:
      return {
        ...state, 
        addPan: action.payload
      }
    case ActionTypes.SET_ONBOARDING_DATA_KYC_VERIFICATION_STATUS:
      return {
        ...state,
        kycVerificationStatus: action.payload.kycVerificationStatus
      }
    case ActionTypes.SET_ONBOARDING_DATA_KYC_DETAILS:
      return {
        ...state,
        kycDetails: action.payload
      }
    case ActionTypes.SET_ONBOARDING_DATA_KYC_CONTACT:
      return {
        ...state,
        kycContactDetails: action.payload
      }
    case ActionTypes.SET_ONBOARDING_KYC_DETAILS:
      return {
        ...state,
        kycDetails: action.payload
      }
    case ActionTypes.SET_ONBOARDING_FLOW_TYPE:
      return {
        ...state,
        onboardingFlowType: action.payload
      }
    case ActionTypes.SET_ONBOARDING_PAN:
      return {
        ...state,
        pan: action.payload
      }
    case ActionTypes.CLEAR_ONBOARDING_DATA:
      return {};
    default:
      return state;
  }
}